module.exports = __webpack_public_path__ + "static/media/add-area.fe489229.svg";